// phonics_data_lt10.js
// Letter Teams L10 - L10 Long Vowel Sounds ie, igh
// 路由：/phonics/lt10

const MEDIA_BASE = '/media/phonics/lt10';
const V = 'v1';

export const letterDataLt10 = {
  id: 'lt10',
  letter: 'L10',
  title: 'L10 Long Vowel Sounds ie, igh',
  mediaBase: MEDIA_BASE,

  // P1: Watch the video (Part 1) → part1.mp4
  part1Video: {
    src: `${MEDIA_BASE}/part1.mp4?${V}`,
  },

  // P2: Repeat the words (Part 3) → part3.mp4
  part3Video: {
    src: `${MEDIA_BASE}/part3.mp4?${V}`,
  },

  // P3: Say the words（静态图片复习）→ review.png
  reviewPic: {
    src: `${MEDIA_BASE}/review.png?${V}`,
  },

  // P7/P8/P9: 三段故事（只有英文台词，无中文）
  storySections: [
    {
      label: 'Learn the story (1)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: "It is late at night.", audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: "Blue has no light.", audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: "He looks left.", audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: "Ahh! It is a snake!", audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: "He looks right.", audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: "Oh no!", audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: "What is that?", audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: "Blue cries and cries.", audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
        { en: "The pals see Blue.", audioEn: `${MEDIA_BASE}/story2_5.mp3?${V}` },
        { en: "It is a snake!", audioEn: `${MEDIA_BASE}/story2_6.mp3?${V}` },
        { en: "Don't cry, Blue.", audioEn: `${MEDIA_BASE}/story2_7.mp3?${V}` },
        { en: "It is not a snake.", audioEn: `${MEDIA_BASE}/story2_8.mp3?${V}` },
        { en: "It is a tie.", audioEn: `${MEDIA_BASE}/story2_9.mp3?${V}` },
        { en: "Oh. A tie!", audioEn: `${MEDIA_BASE}/story2_10.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: "Blue looks right.", audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: "It is a pie!", audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
        { en: "And those are fries.", audioEn: `${MEDIA_BASE}/story3_3.mp3?${V}` },
        { en: "Oh. A pie and fries!", audioEn: `${MEDIA_BASE}/story3_4.mp3?${V}` },
        { en: "The pals look high.", audioEn: `${MEDIA_BASE}/story3_5.mp3?${V}` },
        { en: "What is that?", audioEn: `${MEDIA_BASE}/story3_6.mp3?${V}` },
        { en: "It is Red!", audioEn: `${MEDIA_BASE}/story3_7.mp3?${V}` },
      ],
    },
  ],
};
